import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';

import withId from '../../decorators/withId';

export class TextInput extends Component {
  static propTypes = {
    /** Self explanatory */
    required: PropTypes.bool,
    /** Type for input validation */
    type: PropTypes.string,
    /** Input value */
    value: PropTypes.string,
    /** Placeholder text */
    placeholder: PropTypes.string,
    /** React reference to an input element */
    _inputRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
    /** Disable input */
    disabled: PropTypes.bool,
    /** Gets called when user changes value in input */
    onChange: PropTypes.func,
    /** Controls whether the input is multiline */
    multiline: PropTypes.bool,
    /** Passed to data-id prop on button component
     *  @ignore
     */
    id: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string,
    name: PropTypes.string,
  };

  static defaultProps = {
    value: '',
    required: false,
    type: 'text',
    placeholder: null,
    disabled: false,
    onChange: () => {},
    _inputRef: null,
    multiline: false,
    ariaLabel: null,
    name: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      previousPropValue: props.value,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { value } = nextProps;
    if (value !== prevState.previousPropValue) {
      return {
        value,
        previousPropValue: value,
      };
    }
    return null;
  }

  handleOnChange = (event) => {
    const { onChange } = this.props;
    const { value } = event.target;

    this.setState({ value });
    onChange(value);
  };

  render() {
    const {
      id,
      ariaLabel,
      placeholder,
      disabled,
      multiline,
      type,
      required,
      name,
      _inputRef,
    } = this.props;

    const { value } = this.state;

    return (
      <FormControl
        _ref={_inputRef}
        componentClass={multiline ? 'textarea' : 'input'}
        data-id={id}
        type={type}
        value={value}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
        onChange={this.handleOnChange}
        aria-label={ariaLabel}
        name={name}
        id={id}
        autoComplete="nofill"
      />
    );
  }
}

export default withId('TextInput')(TextInput);
